import React from 'react';
import MainMenu from './MainMenu';

/**
 * WrapMenuTabVer
 */
class WrapMenuTabVer extends React.Component {

  render() {
    return (
      <div id="wrap_menu_tab_ver">
        <div id="area_menu_tab_ver">
          <div id="content_menu" className="fix_height hero_style">
            <MainMenu />
          </div>
        </div>
      </div>
    );
  }
}

export default WrapMenuTabVer;
